"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DragSliderHandle = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const nano_theme_1 = require("nano-theme");
const context_1 = require("../../styles/context");
const blockStaticClass = (0, nano_theme_1.rule)({
    d: 'inline-block',
    pos: 'relative',
    bxz: 'border-box',
    bdrad: '3px',
    us: 'none',
    va: 'middle',
    lh: 0,
    fz: 0,
    trs: 'background .12s ease-out, color .12s ease-out, transform .08s ease-out',
    transformOrigin: '50% 50%',
    transformBox: 'border-box',
});
const blockHoverActiveClass = (0, nano_theme_1.drule)({});
const DragSliderHandle = (props) => {
    const { width = 12, height = 18, disabled, variant = 'bar', className, style } = props;
    const styles = (0, context_1.useStyles)();
    const base = styles.g(0.55);
    const hover = styles.g(0.25);
    const pressed = styles.g(0.1);
    const pseudoCls = blockHoverActiveClass(disabled
        ? {}
        : {
            '&:hover': { col: hover, bg: 'rgba(128,128,128,0.12)' },
            '&:active': { col: pressed, transform: 'scale(.97)' },
        });
    const blockStyle = {
        width,
        height,
        color: base,
        background: 'transparent',
        opacity: disabled ? 0.4 : 1,
        cursor: disabled ? 'default' : 'inherit',
        ...style,
    };
    const blockClassName = blockStaticClass + pseudoCls + (className ? ` ${className}` : '');
    if (variant === 'bar') {
        const barW = Math.max(6, Math.round(width * 0.55));
        const barH = Math.max(8, Math.round(height * 0.7));
        return (React.createElement("span", { className: blockClassName, style: blockStyle },
            React.createElement("span", { style: {
                    position: 'absolute',
                    top: 0,
                    bottom: 0,
                    left: 0,
                    right: 0,
                    margin: 'auto',
                    width: barW,
                    height: barH,
                    borderRadius: 2,
                    background: 'currentColor',
                } })));
    }
    const dot = Math.max(2, Math.round(Math.min(width, height) * 0.22));
    const gap = Math.max(1, dot - 1);
    return (React.createElement("span", { className: blockClassName, style: blockStyle },
        React.createElement("span", { style: {
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                display: 'flex',
                flexDirection: 'column',
                gap,
            } },
            React.createElement("span", { style: { width: dot, height: dot, borderRadius: '50%', background: 'currentColor' } }),
            React.createElement("span", { style: { width: dot, height: dot, borderRadius: '50%', background: 'currentColor' } }),
            React.createElement("span", { style: { width: dot, height: dot, borderRadius: '50%', background: 'currentColor' } }))));
};
exports.DragSliderHandle = DragSliderHandle;
